import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SupportedLocaleCode } from '@ttc/ttc-constants/locale';

import { fadeInGrowEnter } from '@libs/src/animations/animations';
import { locales } from '@libs/src/locale/locale.helper';
import { Locale } from '@libs/src/locale/locale.interface';

@Component({
  animations: [fadeInGrowEnter],
  selector: 'app-localization-drop-down',
  standalone: false,
  templateUrl: './localization-drop-down.component.html',
})
export class LocalizationDropDownComponent implements OnInit {
  selectedLocale: Locale;
  supportedLocales: Locale[] = locales;

  constructor(
    @Inject(LOCALE_ID) private readonly appLocale: string,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.selectedLocale = locales.find(
      (locale) => locale.code === this.appLocale,
    );
  }

  localeSwitched(value: SupportedLocaleCode): void {
    const { queryParams } = this.route.snapshot;
    this.router.navigate([], {
      queryParams: {
        ...queryParams,
        selectedLocale: value,
        skipLocation: true,
      },
    });
  }

  compareByCode(currentLocale: Locale, selectedLocale: Locale): boolean {
    return currentLocale?.code === selectedLocale?.code;
  }
}
